import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './product-average-rating-cta.scss'

const ProductAverageRatingCta = ({
  t,
  onClickCta,
  total_count,
  averageRating,
}) => {
  if (!averageRating) return null

  const reviewText = hasLocizeTranslation(t, 'REVIEWS', 'reviews')

  return (
    <button
      type="button"
      data-cy="product-average-rating-cta-container"
      className="product-average-rating-cta-container"
      onClick={onClickCta}
    >
      <style jsx>{styles}</style>
      <div
        className={clsx(
          'product-average-rating-cta-container__content',
          Typo.body2,
        )}
      >
        <Icon src={ICONS.starGold} size={ICON_SIZE.smallMedium} />
      </div>
      <div className={clsx(Typo.caption)}>{averageRating}</div>
      <div
        className={clsx(
          'product-average-rating-cta-container__content',
          Typo.caption,
        )}
      >{`(${total_count} ${reviewText})`}</div>
    </button>
  )
}

ProductAverageRatingCta.defaultProps = {
  total_count: 0,
  averageRating: null,
}

ProductAverageRatingCta.propTypes = {
  // component props
  t: PropTypes.func.isRequired,
  total_count: PropTypes.number,
  averageRating: PropTypes.number,
  onClickCta: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ProductAverageRatingCta)
